export const BASEURL = '/prod-api'
// export const BASEURL = 'http://127.0.0.1:8080'



// WEBPACK FOOTER //
// ./src/api/config.js